export interface TimerState {
  /** Milliseconds left, clamped to [0, durationMs]. */
  remainingMs: number;
  /** Remaining fraction in [0, 1] (bar width). */
  fraction: number;
  /** Whole seconds shown on the label: ceil(remaining / 1000) — "3" until it hits 2.000 s. */
  seconds: number;
  /** In the last 3 seconds (and not yet expired). */
  urgent: boolean;
  expired: boolean;
}

export const URGENT_MS = 3000;

/** Pure timer maths shared by `TimerBar` (and testable without a DOM). */
export function timerState(deadline: number, durationMs: number, now: number): TimerState {
  const duration = Math.max(1, durationMs);
  const remainingMs = Math.min(duration, Math.max(0, deadline - now));
  const seconds = Math.ceil(remainingMs / 1000);
  return {
    remainingMs,
    fraction: remainingMs / duration,
    seconds,
    urgent: remainingMs > 0 && remainingMs <= URGENT_MS,
    expired: remainingMs <= 0,
  };
}

/** Two-digit seconds label: 9 → "09", 12 → "12". */
export function formatSeconds(seconds: number): string {
  return String(Math.max(0, seconds)).padStart(2, '0');
}
